import { MeetingTool, VirtualSessionDraft } from "../types";

export type SettingSection = "ROLES" | "LOBBY" | "GENERAL" | "LINK" | "INVITE";

export type SettingFieldType = "switch" | "select" | "association" | "text";

export interface MeetingSettingField {
  key: keyof VirtualSessionDraft;
  type: SettingFieldType;
  section: SettingSection;
  required?: boolean;
  optionsKey?: string;
  dependsOn?: keyof VirtualSessionDraft;
  fullWidth?: boolean;
}

export const MEETING_OPTIONS: Record<string, string[]> = {
  meeting_scope: [
    "EVERYONE",
    "INVITED",
    "ORGANIZER",
    "ORGANIZATION",
    "ORGANIZATIONANDFEDERATED",
    "ORGANIZATIONEXCLUDINGGUESTS",
  ],
  meeting_chat: ["ENABLED", "DISABLED", "LIMITED"],
  role_for_presenter: [
    "EVERYONE",
    "ORGANIZATION",
    "ROLE_IS_PRESENTER",
    "ORGANIZER",
  ],
  meeting_access_type: ["OPEN", "TRUSTED", "RESTRICTED"],
  meeting_chat_restriction: ["HOSTS_ONLY", "NO_RESTRICTION"],
};

export const ROLE_FIELDS: Array<keyof VirtualSessionDraft> = [
  "producer",
  "presenter",
  "coorganizer",
  "cohost",
];

export const MEETING_SETTINGS: Record<MeetingTool, MeetingSettingField[]> = {
  MSTEAMS: [
    { key: "producer", type: "association", section: "ROLES" },
    { key: "presenter", type: "association", section: "ROLES" },
    { key: "coorganizer", type: "association", section: "ROLES" },
    { key: "is_dial_in_bypass_enabled", type: "switch", section: "LOBBY" },
    {
      key: "scope",
      type: "select",
      section: "LOBBY",
      optionsKey: "meeting_scope",
      required: true,
    },
    {
      key: "allow_meeting_chat",
      type: "select",
      section: "GENERAL",
      optionsKey: "meeting_chat",
      required: true,
    },
    {
      key: "allow_attendee_to_enable_camera",
      type: "switch",
      section: "GENERAL",
    },
    {
      key: "allow_attendee_to_enable_mic",
      type: "switch",
      section: "GENERAL",
    },
    { key: "allow_breakout_rooms", type: "switch", section: "GENERAL" },
    { key: "allow_recording", type: "switch", section: "GENERAL" },
    { key: "allow_transcription", type: "switch", section: "GENERAL" },
    {
      key: "record_automatically",
      type: "switch",
      section: "GENERAL",
      dependsOn: "allow_recording",
    },
    {
      key: "allowed_presenters",
      type: "select",
      section: "GENERAL",
      optionsKey: "role_for_presenter",
      required: true,
    },
    {
      key: "trigger_external_services",
      type: "switch",
      section: "INVITE",
      fullWidth: true,
    },
    {
      key: "confirmed",
      type: "switch",
      section: "INVITE",
      fullWidth: true,
      dependsOn: "trigger_external_services",
    },
  ],
  GMEET: [
    { key: "cohost", type: "association", section: "ROLES" },
    {
      key: "access_type",
      type: "select",
      section: "LOBBY",
      optionsKey: "meeting_access_type",
      required: true,
    },
    {
      key: "chat_restriction",
      type: "select",
      section: "GENERAL",
      optionsKey: "meeting_chat_restriction",
      required: true,
    },
    {
      key: "default_join_as_viewer_type",
      type: "switch",
      section: "GENERAL",
    },
    {
      key: "auto_transcription_generation",
      type: "switch",
      section: "GENERAL",
    },
    { key: "auto_recording_generation", type: "switch", section: "GENERAL" },
    {
      key: "trigger_external_services",
      type: "switch",
      section: "INVITE",
      fullWidth: true,
    },
    {
      key: "confirmed",
      type: "switch",
      section: "INVITE",
      fullWidth: true,
      dependsOn: "trigger_external_services",
    },
  ],
  OTHER: [
    { key: "link", type: "text", section: "LINK", required: true },
    {
      key: "confirmed",
      type: "switch",
      section: "INVITE",
      fullWidth: true,
    },
  ],
};
